import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IDocumentI18n } from 'document/document-i18n';
import { CoacheeProfileDocumentsController } from 'presentation/page/profile/coachee-profile/coachee-profile-documents/coachee-profile-documents.controller';
import { CoacheeProfileDocumentsStore } from 'presentation/page/profile/coachee-profile/coachee-profile-documents/coachee-profile-documents.store';

@Component({
	selector: 'spr-coachee-profile-documents',
	templateUrl: './coachee-profile-documents.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoacheeProfileDocumentsStore, CoacheeProfileDocumentsController],
	host: {
		class: 'block',
	},
})
export class CoacheeProfileDocumentsComponent {
	constructor(public controller: CoacheeProfileDocumentsController) {}

	public onDateSortClick() {
		this.controller.toggleDateSort();
	}

	public onViewDocumentClick(documentI18n: IDocumentI18n) {
		this.controller.openDocument(documentI18n);
	}

	public onDownloadDocumentClick(documentI18n: IDocumentI18n) {
		this.controller.downloadDocument(documentI18n);
	}

	public onReached() {
		this.controller.loadNextPage();
	}
}
